import { Zap } from "lucide-react";

const ITEMS = [
  "Rhône-Alpes",
  "ImmoPad",
  "Tablette connectée 5G",
  "Flash photo — caves & compteurs",
  "IA d'inventaire",
  "Rapport numérique",
  "Entrée / Sortie",
  "Signatures numériques",
];

export default function EditorialTicker() {
  return (
    <div
      data-testid="editorial-ticker"
      className="relative overflow-hidden border-y border-white/10 bg-surface/60 py-5"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        {[0, 1].map((dup) => (
          <div key={dup} aria-hidden={dup === 1} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
              <span
                key={`${dup}-${item}`}
                className="flex items-center gap-6 px-6 font-mono text-xs uppercase tracking-[0.3em] text-slate-400"
              >
                {item}
                <Zap className="h-3.5 w-3.5 text-cyan-400/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-night to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-night to-transparent" />
    </div>
  );
}
